import { Button, Col, Flex, message, Row, Space, Typography } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useTime from '../../../hooks/useTime';
import PreviewSeatMap from '../../seat-map/PreviewSeatmap';
import IntlMessage from '../../../components/IntlMessage';
import dayjs from 'dayjs';
import busOrdersApi from '../../../api/bus_orders';
import _ from 'lodash';
import {
  updatePassengerDeparture,
  updateSearchBookingValues,
  updateSegmentDeparture,
} from '../../../redux/actions/CreateBookingAction';
import PassengerInfo from './PassengerInfo';
import seatMapApi from '../../../api/seat-map';
import { formatCurrencyCustom } from '../../../utils/helpers';

const Departure = (props) => {
  const { Title, Text } = Typography;
  const searchValues = useSelector(
    (state) => state.createBookings.searchValues,
  );
  const departure = useSelector((state) => state.createBookings.departure);
  const dispatch = useDispatch();
  const { convertToAnyTimezone } = useTime();
  const [viewSeatIndex, setViewSeatIndex] = useState(null);
  const [bookingDetail, setBookingDetail] = useState(null);
  const [selectedSeat, setSelectedSeat] = useState([]);
  const [isOpenPassenger, setIsOpenPassenger] = useState(false);
  const [isLoadingSeat, setIsLoadingSeat] = useState(false);
  const [seat, setSeat] = useState({ id: null, block_layout: null });
  const [busySeat, setBusySeat] = useState({ id: null, block_layout: null });
  const [isUpdateSeat, setIsUpdateSeat] = useState(false);

  const {
    searchData,
    onRefresh,
    onModalFormClose,
    currentData,
    handleSelectSegment,
  } = props;
  const handleViewSeat = async (id, index, price, item) => {
    setIsLoadingSeat(true);
    setBookingDetail(null);

    let filter = {};
    if (searchValues.date) {
      filter.date = convertToAnyTimezone(searchValues.date).format(
        'YYYY-MM-DD',
      );
    }

    setViewSeatIndex(index);
    const newFilter = filter || {
      date: convertToAnyTimezone(new Date()).format('YYYY-MM-DD'),
    };

    try {
      const res = await busOrdersApi.getBookingDetail(id, newFilter);

      if (res) {
        const dateSeatMap = await seatMapApi.getSeatLock(res?.id, newFilter);
        if (dateSeatMap) {
          setBusySeat(dateSeatMap);
        }
        setSeat({
          id: res?.route?.id,
          block_layout: res?.route?.seatmap?.seatmap?.block_layout,
        });

        if (
          currentData &&
          !dayjs(currentData.date).isSame(searchValues.date, 'day')
        ) {
          const booked = res.booked || [];
          const locked = res.locked || [];

          const allUnavailableSeats = [...booked, ...locked];
          console.log(
            'searchValuessearchValuessearchValues',
            searchValues,
            allUnavailableSeats,
          );
          const selectedSeats = currentData?.passengers
            ?.filter(
              (item) =>
                item.seat &&
                !allUnavailableSeats.includes(item.seat) &&
                searchValues.passengers.map((i) => i.id).includes(item.id),
            )
            .map((i) => i.seat);

          console.log(
            'selectedSeatsselectedSeatsselectedSeatsselectedSeats',
            selectedSeats,
          );

          setSelectedSeat(selectedSeats);

          dispatch(
            updateSegmentDeparture({
              segments: {
                segment_id: id,
                date: convertToAnyTimezone(searchValues?.date).format(
                  'YYYY-MM-DD',
                ),
                seat: selectedSeats?.toString(),
                qty: selectedSeats?.length,
                price: price,
              },
            }),
          );
        } else {
          dispatch(
            updateSegmentDeparture({
              segments: {
                segment_id: id,
                date: convertToAnyTimezone(searchValues?.date).format(
                  'YYYY-MM-DD',
                ),
                price: price,
              },
            }),
          );
        }

        console.log('res?.route?.id', res?.route?.id);
        dispatch(
          updateSearchBookingValues({
            route_id: res?.route?.id,
          }),
        );
        setBookingDetail(res);
        handleSelectSegment(res);
        setIsLoadingSeat(false);
      }
    } catch (err) {
      console.error(err);
      setBookingDetail(null);
      handleSelectSegment(null);
      setIsLoadingSeat(false);
      if (err.status === 478) {
        message.warning(
          `La date limite de réservation pour ${
            item?.route?.operator?.title
          } est le ${dayjs(err?.data?.message).format(
            'DD/MM/YYYY',
          )}. Merci de choisir un départ avant ce jour`,
        );
      }
    }
  };

  const handleSelectSeat = async (seat) => {
    setSelectedSeat((prev) =>
      _.includes(prev, seat)
        ? prev.filter((num) => num !== seat)
        : [...prev, seat],
    );
  };

  useEffect(() => {
    const cloneSegmentData = _.cloneDeep(departure?.segments);

    dispatch(
      updateSegmentDeparture({
        selectedSeat_departure: selectedSeat,
        segments: {
          ...cloneSegmentData,
          seat: selectedSeat?.toString(),
          qty: selectedSeat?.length,
        },
      }),
    );
  }, [selectedSeat, searchData, dispatch]);

  useEffect(() => {
    setViewSeatIndex(null);
    setBookingDetail(null);
    setSelectedSeat([]);
  }, [searchData]);

  useEffect(() => {
    const fetch = async () => {
      let filter = {};
      if (searchValues.date) {
        filter.date = convertToAnyTimezone(searchValues.date).format(
          'YYYY-MM-DD',
        );
      }

      const newFilter = filter || {
        date: convertToAnyTimezone(new Date()).format('YYYY-MM-DD'),
      };

      if (isUpdateSeat) {
        const dateSeatMap = await seatMapApi.getSeatLock(
          bookingDetail?.id,
          newFilter,
        );
        if (dateSeatMap) {
          setBusySeat(dateSeatMap);
        }
        setSeat({
          id: bookingDetail?.route?.id,
          block_layout: bookingDetail?.route?.seatmap?.seatmap?.block_layout,
        });
        setIsUpdateSeat(false);
      }
    };
    fetch();
  }, [bookingDetail, isUpdateSeat]);

  const handleNextToPassenger = (segmentId, price) => {
    if (selectedSeat.length < searchValues.pax) {
      message.warning(`Please choose ${searchValues.pax} seats`);
    } else {
      setIsOpenPassenger(true);
    }
  };

  const handleHideSeat = () => {
    setViewSeatIndex(null);
    setBookingDetail(null);
    setSelectedSeat([]);
    dispatch(
      updateSegmentDeparture({
        selectedSeat_departure: [],
      }),
    );
    // dispatch(
    //   updatePassengerDeparture({
    //     passengers_departure: [],
    //   })
    // );
  };
  console.log('bookingDetail1', bookingDetail);
  return (
    <div>
      <Title level={5}>
        {`${searchData[0]?.start_stop.title} - ${
          searchData[0]?.end_stop.title
        } ${convertToAnyTimezone(searchValues?.date).format('DD/MM/YYYY')}`}
      </Title>

      {selectedSeat.length === 0 && searchData
        ? searchData.map((item, i) => {
            return (
              <>
                <div
                  style={{
                    border: '1px solid #000000',
                    padding: 12,
                    marginTop: 20,
                  }}>
                  <Row>
                    <Col span={8}>
                      <Space direction="vertical">
                        {i === 0 ? (
                          <Text strong>
                            <IntlMessage id="global.company" />
                          </Text>
                        ) : null}
                        <Text>{item?.route?.operator?.title}</Text>
                      </Space>
                    </Col>

                    <Col span={8}>
                      <Space direction="vertical">
                        {i === 0 ? (
                          <Text strong>
                            <IntlMessage id="global.departure" />
                          </Text>
                        ) : null}
                        <Text>
                          {dayjs(item?.start_time, 'HH:mm:ss').format('HH:mm')}
                        </Text>
                      </Space>
                    </Col>
                    <Col span={8}>
                      <Space direction="vertical">
                        {i === 0 ? (
                          <Text strong>
                            <IntlMessage id="global.price" />
                          </Text>
                        ) : null}
                        <Text>
                          {formatCurrencyCustom(
                            +item?.from_price,
                            JSON.parse(item?.route?.operator?.params || '{}'),
                          )}{' '}
                        </Text>
                      </Space>
                    </Col>
                  </Row>

                  {viewSeatIndex === i && bookingDetail ? (
                    <>
                      <Flex justify="flex-end">
                        <Button onClick={handleHideSeat}>Masquer le bus</Button>
                      </Flex>
                    </>
                  ) : (
                    <Flex justify="flex-end">
                      <Button
                        onClick={() =>
                          handleViewSeat(item.id, i, item.from_price, item)
                        }
                        loading={isLoadingSeat && viewSeatIndex === i}>
                        Afficher le bus
                      </Button>
                    </Flex>
                  )}
                </div>

                {viewSeatIndex === i && bookingDetail ? (
                  <div
                    style={{
                      border: '1px solid #000000',
                      borderTop: 0,
                      padding: 12,
                    }}>
                    <PreviewSeatMap
                      open={true}
                      selectedSeat={selectedSeat}
                      createBookingData={seat}
                      isModal={false}
                      maxSeat={searchValues.pax}
                      bookingDetail={bookingDetail}
                      handleSelectSeat={handleSelectSeat}
                      busySeat={busySeat}
                      isUpdateSeat={isUpdateSeat}
                      setIsUpdateSeat={setIsUpdateSeat}
                    />

                    {selectedSeat && selectedSeat.length > 0 ? (
                      <Flex
                        style={{ marginTop: 16 }}
                        vertical
                        align="center"
                        gap={8}>
                        <Text key={i}>
                          Seat selected:{' '}
                          <strong>{selectedSeat.join(',')}</strong>
                        </Text>
                        <Flex gap={20}>
                          <Text>
                            Total:{' '}
                            <strong>
                              {formatCurrencyCustom(
                                +bookingDetail.from_price * selectedSeat.length,
                                JSON.parse(
                                  item?.route?.operator?.params || '{}',
                                ),
                              )}{' '}
                            </strong>{' '}
                          </Text>
                        </Flex>
                        {!searchValues.roundtrip ? (
                          <Button
                            type="primary"
                            danger
                            onClick={() =>
                              handleNextToPassenger(item.id, item.from_price)
                            }>
                            Next
                          </Button>
                        ) : null}
                      </Flex>
                    ) : null}
                  </div>
                ) : null}
                <PassengerInfo
                  isOpenPassenger={isOpenPassenger}
                  setIsOpenPassenger={setIsOpenPassenger}
                  bookingDetail
                  onRefresh={onRefresh}
                  onModalFormClose={onModalFormClose}
                />
              </>
            );
          })
        : null}

      {selectedSeat.length > 0 ? (
        <>
          <div
            style={{
              border: '1px solid #000000',
              padding: 12,
              marginTop: 20,
            }}>
            <Row>
              <Col span={8}>
                <Space direction="vertical">
                  <Text strong>
                    <IntlMessage id="global.company" />
                  </Text>
                  <Text>{bookingDetail?.route?.operator?.title}</Text>
                </Space>
              </Col>

              <Col span={8}>
                <Space direction="vertical">
                  <Text strong>
                    <IntlMessage id="global.departure" />
                  </Text>
                  <Text>
                    {dayjs(bookingDetail?.start_time, 'HH:mm:ss').format(
                      'HH:mm',
                    )}
                  </Text>
                </Space>
              </Col>
              <Col span={8}>
                <Space direction="vertical">
                  <Text strong>
                    <IntlMessage id="global.price" />
                  </Text>
                  <Text>
                    {' '}
                    {formatCurrencyCustom(
                      +bookingDetail?.from_price,
                      JSON.parse(
                        bookingDetail?.route?.operator?.params || '{}',
                      ),
                    )}{' '}
                  </Text>
                </Space>
              </Col>
            </Row>

            <>
              <Flex justify="flex-end">
                <Button onClick={handleHideSeat}>Masquer le bus</Button>
              </Flex>
            </>
          </div>

          {bookingDetail ? (
            <div
              style={{
                border: '1px solid #000000',
                borderTop: 0,
                padding: 12,
              }}>
              <PreviewSeatMap
                open={true}
                selectedSeat={selectedSeat}
                createBookingData={seat}
                isModal={false}
                maxSeat={searchValues.pax}
                bookingDetail={bookingDetail}
                handleSelectSeat={handleSelectSeat}
                busySeat={busySeat}
                isUpdateSeat={isUpdateSeat}
                setIsUpdateSeat={setIsUpdateSeat}
              />
              {departure && departure?.seatRealTimeLocked?.length > 0 ? (
                <div style={{ marginTop: 24 }}>
                  <Text type="danger">
                    Seat {departure?.seatRealTimeLocked.toString()} has been
                    taken while you were choosing
                  </Text>
                </div>
              ) : null}
              {selectedSeat && selectedSeat.length > 0 ? (
                <Flex style={{ marginTop: 16 }} vertical align="center" gap={8}>
                  <Text key={'seat'}>
                    Seat selected: <strong>{selectedSeat.join(',')}</strong>
                  </Text>
                  <Flex gap={20}>
                    <Text>
                      Total:{' '}
                      <strong>
                        {formatCurrencyCustom(
                          bookingDetail.from_price * selectedSeat.length,
                          JSON.parse(
                            bookingDetail?.route?.operator?.params || '{}',
                          ),
                        )}
                      </strong>{' '}
                    </Text>
                  </Flex>
                  {/* {!searchValues.roundtrip ? (
                    <Button
                      type="primary"
                      danger
                      onClick={() =>
                        handleNextToPassenger(
                          bookingDetail.id,
                          bookingDetail.from_price
                        )
                      }>
                      Next
                    </Button>
                  ) : null} */}
                </Flex>
              ) : null}
            </div>
          ) : null}
          {isOpenPassenger && (
            <PassengerInfo
              isOpenPassenger={isOpenPassenger}
              setIsOpenPassenger={setIsOpenPassenger}
              segment={bookingDetail}
              onRefresh={onRefresh}
              onModalFormClose={onModalFormClose}
              currentData={currentData}
            />
          )}
        </>
      ) : null}
    </div>
  );
};

export default Departure;
